import { ACTION_LINK_APP, ACTION_UNLINK_APP } from "../actions";

const initState = {
    gate: undefined,
    appid: undefined,
    apkUrl: undefined
}

export const infoAppReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_LINK_APP:
            return { ...state, gate: action.payload.gate, appid: action.payload.appid, apkUrl: action.payload.apkUrl };
        case ACTION_UNLINK_APP:
            return {...state, gate: undefined, appid: undefined}
        default:
            return state;
    }
}